import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../../interfaces/role.interface';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly http = inject(HttpClient);

  createRole(role: Partial<Role>): Observable<Role> {
    return this.http.post<Role>('/api/roles', role);
  }

  updateRole(roleId: string, updates: Partial<Role>): Observable<Role> {
    return this.http.patch<Role>(`/api/roles/${roleId}`, updates);
  }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>('/api/roles');
  }

  getRoleById(id: string): Observable<Role> {
    return this.http.get<Role>(`/api/roles/${id}`);
  }

  deleteRoleById(id: string): Observable<Role> {
    return this.http.delete<Role>(`/api/roles/${id}`);
  }
}
